import { render, staticRenderFns } from "./BuildingShowSurveysTab.vue?vue&type=template&id=5ffade21"
import script from "./BuildingShowSurveysTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowSurveysTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports